import React, { useState, useEffect } from 'react';
import { fetchAvailableCredits } from '../../services/api';
import LoadingButton from '../LoadingButton/LoadingButton';
import './creditSelector.css';

export default function CreditSelector({
  invoice_number,
  invoice_total,
  diesel_tax,
  client_code,
  onConfirm,
  onClose,
}) {
  const [credits, setCredits] = useState([]);

  const selected_credits_sum = () => {
    return credits
      .filter(credit => credit.selected)
      .reduce((sum, credit) => sum + parseFloat(credit.total), 0);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedData = await fetchAvailableCredits(client_code);
        if (fetchedData && Array.isArray(fetchedData.results)) {
          const credits = fetchedData.results;
          const extractedData = credits.map(credit => ({
            ...credit,
            selected: false,
          }));
          setCredits(extractedData);
        } else {
          setCredits([]);
          console.error('La réponse ne contient pas de tableau "results"');
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setCredits([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggleSelect = index => {
    const newCredits = [...credits];
    newCredits[index].selected = !newCredits[index].selected;
    setCredits(newCredits);
  };

  const handleConfirmClick = async e => {
    const selected = credits.filter(credit => credit.selected);
    onConfirm(selected);
  };

  return (
    <div className="overlay">
      <div className="shipment-selector-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <p>Appliquer un/des avoir.s sur la facture {invoice_number}</p>
        <div className="shipments-list credit-selector">
          <table>
            <tbody>
              {credits.map((credit, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      checked={credit.selected}
                      onChange={() => handleToggleSelect(index)}
                    />
                  </td>
                  <td onClick={() => handleToggleSelect(index)}>{credit.invoice_number}</td>
                  <td onClick={() => handleToggleSelect(index)}>{credit.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="shipments-list credit-selector-total-comparison">
          <table>
            <thead>
              <tr>
                <th>
                  <p>Total HT {invoice_number}</p>
                  <p>(avant taxe gasoil)</p>
                </th>
                <th>Total avoirs</th>
                <th>Nouveau Total HT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{parseFloat(invoice_total) - parseFloat(diesel_tax)}</td>
                <td>{selected_credits_sum()}</td>
                <td>
                  {parseFloat(invoice_total) - parseFloat(diesel_tax) + selected_credits_sum()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="shipment-selector-buttons credit-shipment-selector">
          <LoadingButton onClick={handleConfirmClick}>Rééditer la facture</LoadingButton>
        </div>
      </div>
    </div>
  );
}
